/*undefined*/
"use strict";

var $protobuf = require("protobufjs/minimal");

// Common aliases
var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

$root.OutstandingPartFilter = (function() {

    /**
     * Namespace OutstandingPartFilter.
     * @exports OutstandingPartFilter
     * @namespace
     */
    var OutstandingPartFilter = {};

    OutstandingPartFilter.OutstandingPartFilterModel = (function() {

        /**
         * Properties of an OutstandingPartFilterModel.
         * @memberof OutstandingPartFilter
         * @interface IOutstandingPartFilterModel
         * @property {string|null} [quoteNo] OutstandingPartFilterModel quoteNo
         * @property {string|null} [vendor] OutstandingPartFilterModel vendor
         * @property {string|null} [sortColumn] OutstandingPartFilterModel sortColumn
         * @property {string|null} [sortOrder] OutstandingPartFilterModel sortOrder
         * @property {number|null} [pageIndex] OutstandingPartFilterModel pageIndex
         * @property {number|null} [pageSize] OutstandingPartFilterModel pageSize
         */

        /**
         * Constructs a new OutstandingPartFilterModel.
         * @memberof OutstandingPartFilter
         * @classdesc Represents an OutstandingPartFilterModel.
         * @implements IOutstandingPartFilterModel
         * @constructor
         * @param {OutstandingPartFilter.IOutstandingPartFilterModel=} [p] Properties to set
         */
        function OutstandingPartFilterModel(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * OutstandingPartFilterModel quoteNo.
         * @member {string|null|undefined} quoteNo
         * @memberof OutstandingPartFilter.OutstandingPartFilterModel
         * @instance
         */
        OutstandingPartFilterModel.prototype.quoteNo = null;

        /**
         * OutstandingPartFilterModel vendor.
         * @member {string|null|undefined} vendor
         * @memberof OutstandingPartFilter.OutstandingPartFilterModel
         * @instance
         */
        OutstandingPartFilterModel.prototype.vendor = null;

        /**
         * OutstandingPartFilterModel sortColumn.
         * @member {string|null|undefined} sortColumn
         * @memberof OutstandingPartFilter.OutstandingPartFilterModel
         * @instance
         */
        OutstandingPartFilterModel.prototype.sortColumn = null;

        /**
         * OutstandingPartFilterModel sortOrder.
         * @member {string|null|undefined} sortOrder
         * @memberof OutstandingPartFilter.OutstandingPartFilterModel
         * @instance
         */
        OutstandingPartFilterModel.prototype.sortOrder = null;

        /**
         * OutstandingPartFilterModel pageIndex.
         * @member {number|null|undefined} pageIndex
         * @memberof OutstandingPartFilter.OutstandingPartFilterModel
         * @instance
         */
        OutstandingPartFilterModel.prototype.pageIndex = null;

        /**
         * OutstandingPartFilterModel pageSize.
         * @member {number|null|undefined} pageSize
         * @memberof OutstandingPartFilter.OutstandingPartFilterModel
         * @instance
         */
        OutstandingPartFilterModel.prototype.pageSize = null;

        // OneOf field names bound to virtual getters and setters
        var $oneOfFields;

        /**
         * OutstandingPartFilterModel _quoteNo.
         * @member {"quoteNo"|undefined} _quoteNo
         * @memberof OutstandingPartFilter.OutstandingPartFilterModel
         * @instance
         */
        Object.defineProperty(OutstandingPartFilterModel.prototype, "_quoteNo", {
            get: $util.oneOfGetter($oneOfFields = ["quoteNo"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * OutstandingPartFilterModel _vendor.
         * @member {"vendor"|undefined} _vendor
         * @memberof OutstandingPartFilter.OutstandingPartFilterModel
         * @instance
         */
        Object.defineProperty(OutstandingPartFilterModel.prototype, "_vendor", {
            get: $util.oneOfGetter($oneOfFields = ["vendor"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * OutstandingPartFilterModel _sortColumn.
         * @member {"sortColumn"|undefined} _sortColumn
         * @memberof OutstandingPartFilter.OutstandingPartFilterModel
         * @instance
         */
        Object.defineProperty(OutstandingPartFilterModel.prototype, "_sortColumn", {
            get: $util.oneOfGetter($oneOfFields = ["sortColumn"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * OutstandingPartFilterModel _sortOrder.
         * @member {"sortOrder"|undefined} _sortOrder
         * @memberof OutstandingPartFilter.OutstandingPartFilterModel
         * @instance
         */
        Object.defineProperty(OutstandingPartFilterModel.prototype, "_sortOrder", {
            get: $util.oneOfGetter($oneOfFields = ["sortOrder"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * OutstandingPartFilterModel _pageIndex.
         * @member {"pageIndex"|undefined} _pageIndex
         * @memberof OutstandingPartFilter.OutstandingPartFilterModel
         * @instance
         */
        Object.defineProperty(OutstandingPartFilterModel.prototype, "_pageIndex", {
            get: $util.oneOfGetter($oneOfFields = ["pageIndex"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * OutstandingPartFilterModel _pageSize.
         * @member {"pageSize"|undefined} _pageSize
         * @memberof OutstandingPartFilter.OutstandingPartFilterModel
         * @instance
         */
        Object.defineProperty(OutstandingPartFilterModel.prototype, "_pageSize", {
            get: $util.oneOfGetter($oneOfFields = ["pageSize"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Encodes the specified OutstandingPartFilterModel message. Does not implicitly {@link OutstandingPartFilter.OutstandingPartFilterModel.verify|verify} messages.
         * @function encode
         * @memberof OutstandingPartFilter.OutstandingPartFilterModel
         * @static
         * @param {OutstandingPartFilter.IOutstandingPartFilterModel} m OutstandingPartFilterModel message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OutstandingPartFilterModel.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.quoteNo != null && Object.hasOwnProperty.call(m, "quoteNo"))
                w.uint32(10).string(m.quoteNo);
            if (m.vendor != null && Object.hasOwnProperty.call(m, "vendor"))
                w.uint32(18).string(m.vendor);
            if (m.sortColumn != null && Object.hasOwnProperty.call(m, "sortColumn"))
                w.uint32(26).string(m.sortColumn);
            if (m.sortOrder != null && Object.hasOwnProperty.call(m, "sortOrder"))
                w.uint32(34).string(m.sortOrder);
            if (m.pageIndex != null && Object.hasOwnProperty.call(m, "pageIndex"))
                w.uint32(40).int32(m.pageIndex);
            if (m.pageSize != null && Object.hasOwnProperty.call(m, "pageSize"))
                w.uint32(48).int32(m.pageSize);
            return w;
        };

        /**
         * Encodes the specified OutstandingPartFilterModel message, length delimited. Does not implicitly {@link OutstandingPartFilter.OutstandingPartFilterModel.verify|verify} messages.
         * @function encodeDelimited
         * @memberof OutstandingPartFilter.OutstandingPartFilterModel
         * @static
         * @param {OutstandingPartFilter.IOutstandingPartFilterModel} message OutstandingPartFilterModel message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OutstandingPartFilterModel.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an OutstandingPartFilterModel message from the specified reader or buffer.
         * @function decode
         * @memberof OutstandingPartFilter.OutstandingPartFilterModel
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {OutstandingPartFilter.OutstandingPartFilterModel} OutstandingPartFilterModel
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OutstandingPartFilterModel.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.OutstandingPartFilter.OutstandingPartFilterModel();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.quoteNo = r.string();
                    break;
                case 2:
                    m.vendor = r.string();
                    break;
                case 3:
                    m.sortColumn = r.string();
                    break;
                case 4:
                    m.sortOrder = r.string();
                    break;
                case 5:
                    m.pageIndex = r.int32();
                    break;
                case 6:
                    m.pageSize = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        /**
         * Decodes an OutstandingPartFilterModel message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof OutstandingPartFilter.OutstandingPartFilterModel
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {OutstandingPartFilter.OutstandingPartFilterModel} OutstandingPartFilterModel
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OutstandingPartFilterModel.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        return OutstandingPartFilterModel;
    })();

    return OutstandingPartFilter;
})();

module.exports = $root;
